import type { Action, ActionSection } from "@/components/MenuButton";
import { copyTextToClipboard } from "@/lib/copyToClipboard";
import { showErrorSnackbar, showSnackbar } from "@/lib/snackbarUtils";
import { buildMemberPaymentUrl } from "@/lib/urlUtils";

export const COPY_PAYMENT_URL_TEST_ID = "copy-payment-url";
export const COPY_PAYMENT_URL_SUCCESS_MESSAGE = "Payment URL copied";

export function getCopyPaymentUrlAction(
  order: { id: string; type?: string | null; payable: boolean },
  options?: { menuOnly?: boolean; section?: ActionSection }
): Action | null {
  const textToCopy = buildMemberPaymentUrl(order);
  if (!textToCopy) {
    return null;
  }

  return {
    text: "Copy Payment URL",
    iconName: "content_copy",
    testId: COPY_PAYMENT_URL_TEST_ID,
    copyFieldLabel: "payment URL",
    menuOnly: options?.menuOnly,
    section: options?.section,
    onClick: () => {
      void copyTextToClipboard(textToCopy)
        .then(() => showSnackbar(COPY_PAYMENT_URL_SUCCESS_MESSAGE))
        .catch(() => showErrorSnackbar("Failed to copy payment URL"));
    }
  };
}
